import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import CommentTiptapEditor from '@wix/da-editor-tiptap/pkg/components/Editor/presets/Comment';
import { UseEditorOptions } from '@wix/da-editor-tiptap/pkg/hooks/useEditor';
import useEditorNg from '../DaEditorNg/hooks/useEditorNg';
import EditorCommon from '../DaEditorNg/EditorCommon';
import { CommentEditorContext } from './context';
import { CommentEditorSource } from '../CommentEditor/redux/types';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';

export interface Props {
  className?: string;
  placeholder?: string;
  onChange?: UseEditorOptions['onEditorChange'];
  loadingIndicator?: React.ReactNode;
  onEditorReady?: UseEditorOptions['onEditorReady'];
  // TODO: Remove? Integrate the following?
  onFocus?: UseEditorOptions['onFocus'];
}

const CommentEditor: React.FC<Props> = React.memo(props => {
  const { onChange, className, loadingIndicator, placeholder, onEditorReady } =
    props;
  const { t } = useTranslation();
  const { initialContent, editorSource, rootElementRef } =
    useContext(CommentEditorContext);

  const { editorProps, editorSharedProps, editorCommonProps } = useEditorNg({
    onEditorChange: onChange,
    onEditorReady: onEditorReady,
  });

  return (
    <ErrorBoundary debugComponent="CommentEditor">
      <EditorCommon {...editorCommonProps} />
      <CommentTiptapEditor
        {...editorSharedProps}
        {...editorProps}
        rootElementRef={rootElementRef as any}
        className={className}
        placeholder={
          placeholder ??
          (editorSource === CommentEditorSource.Reply
            ? t('commentbox.editor.placeholder.reply')
            : t('commentbox.editor.placeholder'))
        }
        cookieType={undefined}
        loadingIndicator={loadingIndicator}
        initialContent={initialContent}
      />
    </ErrorBoundary>
  );
});
CommentEditor.displayName = 'SharedCommentEditor';

export default CommentEditor;
